import { useMemo } from "react";
import theme from "../../../../../theme";

import useBreakpoint from "../../../../hooks/useBreakpoint";

const useDropdownOptionHeight = () => {
    const { minWidth } = useBreakpoint();

    const dropdownOptionHeight = useMemo(() => {
        switch (true) {
            case minWidth >= theme.breakpoints.sizes["5xl"]:
                return 47;
            case minWidth >= theme.breakpoints.sizes["xl"]:
                return 43;
            default:
                return 35;
        }
    }, [minWidth]);

    return dropdownOptionHeight;
};

export default useDropdownOptionHeight;
